module.exports = __webpack_public_path__ + "img/actors-home.8902c72a.jpg";